// inclusive at min, exclusive at max - TMA (24 Sep 2019)
export const getRandomNum = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min) + min);

export const validatePageParam = (searchParams: URLSearchParams): number => {
  const stringVal = searchParams.get('page');
  let numericVal = Number(stringVal);

  if (!stringVal || !Number.isInteger(numericVal) || numericVal > 500) {
    searchParams.set('page', '1');
    numericVal = 1;
  }

  return numericVal;
};
